export function hasSearch(data) {
  return data.query;
}

export function hasDate(data) {
  return data.dateRangeFrom && data.dateRangeTo;
}

export function hasType(data) {
  return (Array.isArray(data.must) && data.must[0]) || (Array.isArray(data.mustNot) && data.mustNot[0]);
}

export const gauss = [
  {
    gauss: {
      collectionDateTimeLocal: {
        origin: 'now',
        scale: '14d',
        decay: 0.75,
        offset: '1d',
      },
    },
  },
];

function getMultiMatch(data) {
  return {
    query: data.query,
    type: 'cross_fields',
    operator: 'and',
    fields: [
      // eslint-disable-next-line no-restricted-globals
      isNaN(data.query.trim()) ? 'bookingId.keyword^5' : 'bookingId^5',
      'firstName^3',
      'lastName^2',
      'customerEmail^2',
      'vrm^3',
      'masterStatusName^5',
      'garageName^2',
      'collectionCity',
      'collectionLine^2',
      'collectionPostcode^2',
      'deliveryCity',
      'deliveryLine^2',
      'deliveryPostcode^2',
      'tags',
    ],
  };
}

function getDateRange(data) {
  return {
    should: [
      {
        range: {
          collectionDateTimeLocal: {
            gte: data.dateRangeFrom,
            lte: data.dateRangeTo,
          },
        },
      },
      {
        range: {
          deliveryDateTimeLocal: {
            gte: data.dateRangeFrom,
            lte: data.dateRangeTo,
          },
        },
      },
    ],
  };
}

function getTypeMatch(data) {
  const must = data.must;
  const mustNot = data.mustNot;
  const match = {};
  if (must && must.length) {
    match.must = must.map((term) => ({ term }));
  }
  if (mustNot && mustNot.length) {
    match.must_not = mustNot.map((term) => ({ term }));
  }
  return match;
}

export function searchQuery(data) {
  return {
    function_score: {
      query: {
        multi_match: getMultiMatch(data),
      },
      functions: gauss,
    },
  };
}

export function dateFilterQuery(data) {
  return {
    function_score: {
      query: {
        bool: {
          ...getDateRange(data),
        },
      },
      functions: gauss,
    },
  };
}

export function searchAndDateFilterQuery(data) {
  return {
    function_score: {
      query: {
        bool: {
          must: [
            {
              multi_match: getMultiMatch(data),
            },
          ],
          filter: {
            bool: {
              ...getDateRange(data),
            },
          },
        },
      },
      functions: gauss,
    },
  };
}

export function query(data) {
  let basicQueryObject = {
    function_score: {
      query: {
        bool: {
          must: [
            {
              match_all: {},
            },
          ],
        },
      },
      // Don't apply Gaussian decay when date filtering is active
      // as it penalizes past bookings and prevents them from showing
      functions: hasDate(data) ? [] : gauss,
    },
  };

  if (hasSearch(data) || hasType(data)) {
    basicQueryObject['function_score'].query.bool.must = [];
  }

  if (hasSearch(data)) {
    basicQueryObject['function_score'].query.bool.must.push({
      multi_match: getMultiMatch(data),
    });
  }

  if (hasType(data)) {
    basicQueryObject['function_score'].query.bool.must.push({
      bool: getTypeMatch(data),
    });
  }

  if (hasDate(data)) {
    basicQueryObject['function_score'].query.bool.filter = {
      bool: getDateRange(data),
    };
  }

  return basicQueryObject;
}
